import React, { useState, useContext, useEffect, useRef } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import openSocket from 'socket.io-client'
import FilterPanel from '../../components/organisms/FilterPanel'
import GridView from '../../components/molecules/ProductCard/GridView'
import './Search.css'
import CustomSelect from '../../components/atoms/Inputs/CustomSelect'
import { Button, MenuItem } from '@material-ui/core'
import ListView from '../../components/molecules/ProductCard/ListView'
import Drawer from '@material-ui/core/Drawer'
// import ProductView from '../../components/organisms/ProductView'
import ProductContext from '../../context/product/productContext'
import AuthContext from '../../context/auth/authContext'
import AlertContext from '../../context/alert/alertContext'
import CommonContext from '../../context/common/commonContext'
import { Pagination } from '@material-ui/lab'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import { useFormik } from 'formik'
import Banner from '../../components/molecules/Banner'
import AuctionOfTheWeek from '../../components/molecules/AuctionOfTheWeek'
import { messageHandler } from '../Common/socketHandler'
import { handleRedirectInternal, useCustomMediaQuery } from '../../common/components'
import SearchNav from '../../components/molecules/SearchNav'
import Loader from '../../components/molecules/Loader'
import PrimaryButton from '../../components/atoms/PrimaryButton'

const useStyles = makeStyles({
    fullList: {
        width: 'auto',
    },
})
const OUTLET_THEME_CLASS = 'search-outlet-theme'

const Search = () => {
    const productContext = useContext(ProductContext)
    const authContext = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const commonContext = useContext(CommonContext)
    const { setSearchValue, searchValue, phrase } = commonContext
    const { type } = useParams()
    const params = new URLSearchParams(window.location.search.substring(1))
    const [completed, setCompleted] = useState(type === 'completed')
    // useEffect(() => {
    //     setCompleted(type === 'completed')
    // }, [type])
    const classes = useStyles()
    const history = useHistory()
    const {
        search_allproducts,
        getAllSearchProducts,
        responseStatus,
        getProjectsMain,
        getProjectsSpotlight,
        projectsMain_spotlight,
        projectsMain,
        getProjectsCompleted,
        projectCompleted,
        dispatchSelectedCategories,
        selectedCategories,
        projmainloading,
        projcompletedloading,
    } = productContext

    const { user, isAuthenticated, saveSearch } = authContext

    const { setAlert } = alertContext
    const isOutlet = location.pathname.includes('/search/outlet')

    const [auctionView, setAuctionView] = useState('Grid')
    const [state, setState] = useState({
        right: false,
        bottom: false,
        left: false,
        data: {},
    })
    let [viewSpotlightProduct, setViewSpotlightProduct] = useState([])
    let [viewProduct, setViewProduct] = useState([])
    let [outletCount, setOutletCount] = useState([])
    let [projectsMainCompleted, setProjectsMainCompleted] = useState([])
    const [spotlightProduct, setSpotlightProduct] = useState(null)
    const [projectsMainPayload, setProjectsMainPayload] = useState({
        ajax: 1,
        sh_limit: 45,
        orderby: searchValue.orderby ? searchValue.orderby : 3,
        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
        page: 1,
        pagecom: 1,
        condition: '',
        lottype: '',
        category: '',
        view: '',
        listfmt: '',
        listfmtnew: '',
        reglist: '',
        countrylist: '',
        auction_format: isOutlet ? 'outlet' : 'normal',
    })
    // search form for ended auctions
    const [endedProjectsPayload, setEndedProjectsPayload] = useState({
        ajax: 1,
        sh_limit: completed ? 45 : 6,
        orderby: searchValue.orderby ? searchValue.orderby : 3,
        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
        page: 1,
        pagecom: 1,
        condition: '',
        lottype: '',
        category: '',
        view: '',
        listfmt: '',
        listfmtnew: '',
        reglist: '',
        countrylist: '',
        auction_format: isOutlet ? 'outlet' : 'normal',
    })
    let [pageOptionsSelected, setPageOptionsSelected] = useState({
        value: 45,
    })
    // 3 is default for Price Low - High
    let [sortShowSelected, setShortshowSelected] = useState({
        value: searchValue.orderby ? searchValue.orderby : 3,
    })
    const [bannerList, setBannerList] = useState([])

    const pageOptions = [
        {
            value: '15',
            show: '15',
        },
        {
            value: '30',
            show: '30',
        },
        {
            value: '45',
            show: '45',
        },
    ]

    const sortShow = [
        {
            value: 1,
            show: phrase.ending_soon,
        },
        {
            value: 2,
            show: phrase.newly_added,
        },
        {
            value: 3,
            show: phrase.price_low_high,
        },
        {
            value: 4,
            show: phrase.price_high_low,
        },
    ]

    const formik = useFormik({
        initialValues: {
            searchbar: '',
        },
    })
    const totalPages =
        projectsMain?.totalRecords && projectsMainPayload?.sh_limit
            ? Math.ceil(projectsMain.totalRecords / projectsMainPayload.sh_limit)
            : 0
    const showRecentlyClosedAuctionsSection =
        projcompletedloading ||
        Number(projectCompleted?.totalRecords || 0) > 0 ||
        projectsMainCompleted.length > 0

    useEffect(() => {
        if (isOutlet) {
            document.body.classList.add(OUTLET_THEME_CLASS)
        } else {
            document.body.classList.remove(OUTLET_THEME_CLASS)
        }

        return () => {
            document.body.classList.remove(OUTLET_THEME_CLASS)
        }
    }, [isOutlet])

    // user hit keys on top keyword search input
    const handleKeyDown = (event) => {
        let { key } = event
        let { value } = event.target
        setSearchValue({ ...searchValue, searchbar: value })
        if (key === 'Enter') {
            let payload = {
                ...projectsMainPayload,
                searchbar: value,
            }
            setProjectsMainPayload(payload)
            setEndedProjectsPayload(payload)
        }
    }
    useEffect(() => {
        setProjectsMainPayload((prev) => ({
            ...prev,
            auction_format: isOutlet ? 'outlet' : 'normal',
            page: 1,
        }))
        setEndedProjectsPayload((prev) => ({
            ...prev,
            auction_format: isOutlet ? 'outlet' : 'normal',
            page: 1,
            pagecom: 1,
        }))
    }, [isOutlet])
    // user hit on search icon on top bar
    const searchBarSubmit = () => {
        let payload = {
            ...projectsMainPayload,
            searchbar: searchValue.searchbar,
        }
        setProjectsMainPayload(payload)
        setEndedProjectsPayload(payload)
    }

    useEffect(() => {
        document.title = global.site_title + ' | Search'
        getAllSearchProducts({}, 'search')
    }, [])

    useEffect(() => {
        if (
            typeof search_allproducts.banner !== 'undefined' &&
            search_allproducts.banner.length > 0
        ) {
            setBannerList(search_allproducts.banner)
        }
    }, [search_allproducts])

    const initialLoad = useRef(true)
    const updateAuctionOfWeek = (prev, message, type) => {
        if (!prev) {
            return prev
        }
        if (prev.id !== message.id) {
            return prev
        }
        const updated = { ...prev }
        if (type === 'bidAddtime') {
            if (message.bpop_wprice) updated.wprice = message.bpop_wprice
            if (message.date_closed) updated.date_closed = message.date_closed
        }
        return updated
    }
    useEffect(() => {
        // this is because, this useffect will be called again once the [selectedcategories] useeffect is invoked
        if (initialLoad.current) {
            initialLoad.current = false
        } else {
            if (Object.keys(projectsMainPayload).length) {
                if (!completed) {
                    getProjectsMain(projectsMainPayload)
                    getProjectsSpotlight()
                }
            }
        }
    }, [projectsMainPayload, completed])

    const initialLoadEndedProjects = useRef(true)

    useEffect(() => {
        if (initialLoadEndedProjects.current) {
            initialLoadEndedProjects.current = false
            return
        }

        if (!Object.keys(endedProjectsPayload).length) return

        if (completed) {
            getProjectsCompleted(endedProjectsPayload)
        } else {
            getProjectsCompleted({
                ...endedProjectsPayload,
                sh_limit: 6,
                pagecom: 1,
            })
        }
    }, [endedProjectsPayload, completed])
    useEffect(() => {
        const interval = setInterval(() => {
            const btn = document.querySelector('.outletBtn button.MuiButton-containedPrimary')
            if (!btn) return

            btn.classList.remove('pulse')
            void btn.offsetWidth // restart animation
            btn.classList.add('pulse')
        }, 3000)
        return () => clearInterval(interval)
    }, [])

    // loaded active auctions
    useEffect(() => {
        if (
            typeof projectsMain.projectsMainArr !== 'undefined' &&
            Array.isArray(projectsMain.projectsMainArr)
        ) {
            setOutletCount(projectsMain.outletAuctionsCount)
            setViewProduct(projectsMain.projectsMainArr)
        }
    }, [projectsMain])
    useEffect(() => {
        if (projectsMain_spotlight?.projectsMainArr?.length > 0) {
            setViewSpotlightProduct(projectsMain_spotlight.projectsMainArr)
            setSpotlightProduct(projectsMain_spotlight.projectsMainArr[0])
        }
    }, [projectsMain_spotlight])

    // loaded ended auctions
    useEffect(() => {
        if (typeof projectCompleted !== 'undefined' && Object.keys(projectCompleted).length) {
            if (typeof projectCompleted.projcompletedArr !== 'undefined') {
                setProjectsMainCompleted(projectCompleted.projcompletedArr)
            }
        }
    }, [projectCompleted])

    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)
    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
    })

    const handler = (message, type, noBadge = false) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
            noBadge,
        )
        setSpotlightProduct((prev) => {
            return updateAuctionOfWeek(prev, message, type)
        })
    }

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'watchlist') {
                handler(
                    {
                        id: responseStatus.data.project_id,
                        status: responseStatus.data.status,
                    },
                    'watchlistAdded',
                )
            }
        }
    }, [responseStatus])

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, { transports: ['websocket'] })
        const onRealClosedUpdates = (data) => {
            handler(data, 'realclosedupdates')
        }
        const onBidAddtime = (data) => {
            handler(data, 'bidAddtime', true)
        }
        const onDropPrice = (data) => {
            handler(data, 'drop_price')
        }
        const onCancelBidEmitted = (data) => {
            cancelBidHandler(data)
        }
        const onBidExtended = (data) => {
            handler(data, 'bid_extended')
        }

        socket.on('realclosedupdates', onRealClosedUpdates)
        socket.on('bidAddtime', onBidAddtime)
        socket.on('drop_price', onDropPrice)

        socket.on('cancelbidemitted', onCancelBidEmitted)
        socket.on('bid_extended', onBidExtended)

        return () => {
            socket.off('realclosedupdates', onRealClosedUpdates)
            socket.off('bidAddtime', onBidAddtime)
            socket.off('drop_price', onDropPrice)
            socket.off('cancelbidemitted', onCancelBidEmitted)
            socket.off('bid_extended', onBidExtended)
            socket.disconnect()
        }
    }, [])

    useEffect(() => {
        if (state.right) {
            const index = viewProduct.findIndex((s) => s.id == parseInt(state.data.id, 10))
            if (index !== -1) {
                setState({ ...state, data: viewProduct[index] })
            }
        }
    }, [viewProduct])

    const fromArrToStr = (arr, type, isName, isregion) => {
        return arr
            .filter((ele) => {
                if (isregion) return ele.type === type && typeof ele.country === 'undefined'
                return ele.type === type
            })
            .map((ele) => {
                return ele.filterBy
                //return isName ? ele.name : ele.id
            })
            .join()
    }

    // page changed - active auctions
    const onHandlePage = (event, value) => {
        setProjectsMainPayload({ ...projectsMainPayload, page: value })
    }

    // page changed - ended auctions
    const onHandlePageEndedAuctions = (event, value) => {
        setEndedProjectsPayload({ ...endedProjectsPayload, page: value, pagecom: value })
    }

    useEffect(() => {
        if (typeof projectsMainPayload !== 'undefined') {
            if (Object.keys(projectsMainPayload).length) {
                if (Array.isArray(selectedCategories) && selectedCategories.length) {
                    let category = fromArrToStr(selectedCategories, 'category', 0, 0)
                    let sub_category = fromArrToStr(selectedCategories, 'sub_category', 0, 0)
                    let condition = fromArrToStr(selectedCategories, 'condition', 0, 0)
                    let listfmt = fromArrToStr(selectedCategories, 'listing', 1, 0)
                    let reglist = fromArrToStr(selectedCategories, 'region', 0, 1)
                    let countrylist = fromArrToStr(selectedCategories, 'region', 0, 0)
                    let lottype = fromArrToStr(selectedCategories, 'lot', 1, 0)
                    let payload = {
                        ...projectsMainPayload,
                        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
                        orderby: sortShowSelected.value,
                        category: category,
                        sub_category,
                        condition: condition,
                        listfmt: listfmt,
                        reglist: reglist,
                        countrylist: countrylist,
                        lottype: lottype,
                        page: 1,
                    }
                    let payloadEndedAuctions = {
                        ...endedProjectsPayload,
                        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
                        orderby: sortShowSelected.value,
                        category: category,
                        sub_category,
                        condition: condition,
                        listfmt: listfmt,
                        reglist: reglist,
                        countrylist: countrylist,
                        lottype: lottype,
                        page: 1,
                    }
                    setProjectsMainPayload(payload)
                    setEndedProjectsPayload(payloadEndedAuctions)
                }
                // no filter selected
                else {
                    let payload = {
                        ...projectsMainPayload,
                        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
                        orderby: sortShowSelected.value,
                        category: '',
                        sub_category: '',
                        condition: '',
                        listfmt: '',
                        reglist: '',
                        countrylist: '',
                        lottype: '',
                        page: 1,
                    }
                    let payloadEndedAuctions = {
                        ...endedProjectsPayload,
                        searchbar: searchValue.searchbar ? searchValue.searchbar : '',
                        orderby: sortShowSelected.value,
                        category: '',
                        sub_category: '',
                        condition: '',
                        listfmt: '',
                        reglist: '',
                        countrylist: '',
                        lottype: '',
                        page: 1,
                    }
                    setProjectsMainPayload(payload)
                    setEndedProjectsPayload(payloadEndedAuctions)
                }
            }
        }
    }, [selectedCategories])

    // show results - per page value changed
    const pageOptionIntialLoad = useRef(true)
    useEffect(() => {
        if (
            typeof pageOptionsSelected.value !== 'undefined' &&
            pageOptionIntialLoad.current == false
        ) {
            let payload = {
                ...projectsMainPayload,
                sh_limit: pageOptionsSelected.value,
            }
            let payloadEndedAuctions = {
                ...endedProjectsPayload,
                sh_limit: pageOptionsSelected.value,
            }
            setProjectsMainPayload(payload)
            setEndedProjectsPayload(payloadEndedAuctions)
        }
        // don't update the main payload initially
        else {
            pageOptionIntialLoad.current = false
        }
    }, [pageOptionsSelected.value])

    const toggleDrawer = (anchor, open, data) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return
        }
        if (open) {
            setState({ ...state, [anchor]: open, data: data })
        } else {
            setState({ ...state, [anchor]: open, data: {} })
        }
    }

    const clearSearchFilter = () => {
        setSearchValue({ ...searchValue, searchbar: '' })
        dispatchSelectedCategories([])
        setProjectsMainPayload((prev) => ({
            ...prev,
            searchbar: '',
            category: '',
            sub_category: '',
            condition: '',
            listfmt: '',
            reglist: '',
            countrylist: '',
            lottype: '',
            page: 1,
            auction_format: isOutlet ? 'outlet' : 'normal',
        }))

        setEndedProjectsPayload((prev) => ({
            ...prev,
            searchbar: '',
            category: '',
            sub_category: '',
            condition: '',
            listfmt: '',
            reglist: '',
            countrylist: '',
            lottype: '',
            page: 1,
            auction_format: isOutlet ? 'outlet' : 'normal',
        }))

        formik.values.searchbar = ''
    }
    const searchFilterFunc = ({ id, name, type, country, filterBy }, isclearAll) => {
        if (isclearAll) {
            setShortshowSelected({ value: 3 }) // set the sort by to default
            dispatchSelectedCategories([])
            setSearchValue({ ...searchValue, searchbar: '' })
            return
        }
        let selcat = [...selectedCategories]
        const selectedInd = selcat.findIndex((ele) => ele.id.toString() === id.toString())
        if (selectedInd >= 0) {
            selcat.splice(selectedInd, 1)
        } else {
            selcat.push({
                id,
                name,
                type: type,
                country,
                filterBy: filterBy,
            })
        }
        dispatchSelectedCategories(selcat)
    }

    const perPageChange = (event) => {
        let { value } = event.target
        let payload = {
            ...projectsMainPayload,
            sh_limit: value,
            page: 1,
        }
        let payloadEndedAuctions = {
            ...endedProjectsPayload,
            sh_limit: value,
        }
        setProjectsMainPayload(payload)
        setEndedProjectsPayload(payloadEndedAuctions)
        setPageOptionsSelected({ value })
    }

    // sort by option changed
    const sortByChange = (event) => {
        let { value } = event.target
        let payload = {
            ...projectsMainPayload,
            orderby: value,
        }
        let payloadEndedAuctions = {
            ...endedProjectsPayload,
            orderby: value,
        }
        setProjectsMainPayload(payload)
        setEndedProjectsPayload(payloadEndedAuctions)
        setShortshowSelected({ value })
    }
    return (
        <>
            {/* {completed ? null : ( */}
            <SearchNav
                searchFilterFunc={searchFilterFunc}
                sortByChange={sortByChange}
                searchBarValue={searchValue.searchbar}
                searchBarSubmit={searchBarSubmit}
                searchInv={handleKeyDown}
                completed={completed}
            />
            {/* )} */}
            <div className="search container-fluid ">
                <div className="searchCnt d-flex justify-content-start align-items-start customContainer">
                    <div className="searchLt"></div>
                    <div className="searchRt">
                        {!completed && isOutlet && (
                            <>
                                {' '}
                                <div className="d-flex justify-content-start">
                                    <Button
                                        className="backBtn my-2"
                                        onClick={() => history.goBack()}
                                    >
                                        <span className="material-icons">arrow_back</span>
                                        {phrase.back_to_main_auction || 'Back to Main Auction'}
                                    </Button>
                                </div>
                                <h2 className="outletAuction">
                                    <img src="/assets/images/outlet_banner.png" />
                                </h2>
                            </>
                        )}
                        <div className="mb-3 searchTitleCnt d-flex justify-content-start align-items-center flex-wrap">
                            {!completed && (
                                <div className="searchTitle">
                                    <h3>
                                        {(() => {
                                            let a = sortShow.find(
                                                (ele) => ele.value === sortShowSelected.value,
                                            )
                                            return a.show
                                        })()}
                                    </h3>
                                    <h6>
                                        {projectsMain.set_disp} OF {projectsMain.totalRecords} LOTS
                                    </h6>
                                </div>
                            )}
                            {/* {completed && (
                                <div className="searchTitle">
                                    <h3>
                                        {(() => {
                                            let a = sortShow.find(
                                                (ele) => ele.value === sortShowSelected.value,
                                            )
                                            return a.show
                                        })()}
                                    </h3>
                                    <h6>
                                        {projectCompleted.total_onlycompleted == 0
                                            ? 0
                                            : projectCompleted.set_disp}{' '}
                                        OF{' '}
                                        {projectCompleted.total_onlycompleted == 0
                                            ? 0
                                            : projectCompleted.totalRecords}{' '}
                                        LOTS
                                    </h6>
                                </div>
                            )} */}
                            <div
                                className={
                                    completed
                                        ? 'searchMiscFilters searchMiscFilterss w-100 d-flex justify-content-end align-items-end'
                                        : 'searchMiscFilters w-100 d-flex justify-content-end align-items-end'
                                }
                            >
                                <div className="gridListToggle">
                                    <Button
                                        className={auctionView === 'Grid' ? 'active' : ''}
                                        onClick={() => setAuctionView('Grid')}
                                    >
                                        <span className="material-icons">apps</span> {phrase.grid}
                                    </Button>
                                    <Button
                                        className={auctionView === 'List' ? 'active' : ''}
                                        onClick={() => setAuctionView('List')}
                                    >
                                        <span className="material-icons">view_list</span>
                                        {phrase.list}
                                    </Button>
                                </div>
                                <div className="rpe d-flex justify-content-between align-items-center">
                                    <label>{phrase.show_results}</label>
                                    <CustomSelect
                                        name="resultsPerPage"
                                        selectType="noBorder"
                                        size="small"
                                        onChange={perPageChange}
                                        value={pageOptionsSelected.value}
                                    >
                                        {pageOptions.map((opt, optindex) => (
                                            <MenuItem key={optindex} value={opt.value}>
                                                {opt.show}
                                            </MenuItem>
                                        ))}
                                    </CustomSelect>
                                </div>
                                <div className="sort d-flex justify-content-between align-items-center">
                                    <label>{phrase.sort_by}</label>
                                    <CustomSelect
                                        size="small"
                                        selectType="noBorder"
                                        name="orderby"
                                        // shrink={search.orderby !== '' ? true : false}
                                        onChange={sortByChange}
                                        value={sortShowSelected.value}
                                    >
                                        {sortShow.map((opt, optindex) => (
                                            <MenuItem key={optindex} value={opt.value}>
                                                {opt.show}
                                            </MenuItem>
                                        ))}
                                    </CustomSelect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {viewSpotlightProduct.length > 0 && !completed && !isOutlet ? (
                    <section className={isAuthenticated ? 'spotSection' : 'spotSection notAuth'}>
                        {projmainloading ? (
                            <Loader />
                        ) : (
                            <div className="spotLightBg searchCnt d-flex justify-content-start align-items-start ">
                                <div className="newDivSpotted customContainer">
                                    <div className="searchLt"></div>
                                    <div className="searchRt">
                                        {!completed && viewSpotlightProduct.length > 0 && (
                                            <h2 className="auctionWeek">
                                                {phrase.auction_of_the_week.toUpperCase()}
                                            </h2>
                                        )}
                                        <div className="spotlightAuction searchRt customContainer">
                                            {viewSpotlightProduct.length > 0 && (
                                                <div className="auction-of-the-week-container">
                                                    <Link
                                                        to={`/product/view/${viewSpotlightProduct[0].id}`}
                                                    >
                                                        <AuctionOfTheWeek
                                                            data={
                                                                spotlightProduct ||
                                                                viewSpotlightProduct[0]
                                                            }
                                                            phrase={phrase}
                                                            onClick={() =>
                                                                handleRedirectInternal(
                                                                    history,
                                                                    `/product/view/${viewSpotlightProduct[0].id}`,
                                                                )
                                                            }
                                                        />
                                                    </Link>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </section>
                ) : null}
                <div className="searchCnt searcf d-flex justify-content-start align-items-start customContainer">
                    <div className="searchLt">
                        {useCustomMediaQuery('(min-width: 1024px)') ? (
                            <div className="deskFilter">
                                <FilterPanel
                                    // setSearch={setSearch}
                                    clearSearch={clearSearchFilter}
                                    //search={search}
                                    page="search"
                                    from={1}
                                    searchFilterFunc={searchFilterFunc}
                                />
                                {!completed &&
                                    outletCount > 0 &&
                                    (() => {
                                        const ButtonComponent = isOutlet ? Button : PrimaryButton
                                        const auctionFormat = isOutlet ? 'normal' : 'outlet'
                                        const route = isOutlet ? '/search' : '/search/outlet'

                                        return (
                                            <ButtonComponent
                                                className="outletBtn"
                                                onClick={() => {
                                                    clearSearchFilter()
                                                    setProjectsMainPayload((prev) => ({
                                                        ...prev,
                                                        auction_format: auctionFormat,
                                                        page: 1,
                                                    }))
                                                    history.push(route)
                                                }}
                                            >
                                                <img
                                                    src="/assets/images/outlet_ledmax_btn1.png"
                                                    alt="Outlet"
                                                />
                                            </ButtonComponent>
                                        )
                                    })()}
                            </div>
                        ) : (
                            <Drawer
                                anchor="left"
                                open={state['left']}
                                className="responsiveFilterDrawer"
                                onClose={toggleDrawer('left', false)}
                                onOpen={toggleDrawer('left', true)}
                            >
                                <div
                                    className={clsx(classes.list, 'left')}
                                    role="presentation"
                                    // onClick={toggleDrawer('left', false)}
                                    onKeyDown={toggleDrawer('left', false)}
                                >
                                    <FilterPanel
                                        // setSearch={setSearch}
                                        clearSearch={clearSearchFilter}
                                        //search={search}
                                        page="search"
                                        from={1}
                                        searchFilterFunc={searchFilterFunc}
                                    />
                                </div>
                            </Drawer>
                        )}
                    </div>
                    {!completed ? (
                        <div className="searchRt">
                            {projmainloading ? (
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{ minHeight: '300px' }}
                                >
                                    <Loader />
                                </div>
                            ) : viewProduct?.length > 0 ? (
                                <div className={`searchResults ${auctionView}`}>
                                    {viewProduct
                                        .filter((item) => {
                                            if (viewSpotlightProduct.length === 0) return true
                                            return item.id !== viewSpotlightProduct[0]?.id
                                        })
                                        .map((data) => (
                                            <React.Fragment key={data.id}>
                                                {auctionView === 'Grid' ? (
                                                    <GridView
                                                        data={data}
                                                        favId={`searchProd_${data.id}`}
                                                        drawerHandler={toggleDrawer(
                                                            'right',
                                                            true,
                                                            data,
                                                        )}
                                                        isOutlet={isOutlet ? 'black' : undefined}
                                                    />
                                                ) : (
                                                    <ListView
                                                        data={data}
                                                        favId={`searchProd_${data.id}`}
                                                        drawerHandler={toggleDrawer(
                                                            'right',
                                                            true,
                                                            data,
                                                        )}
                                                        isOutlet={isOutlet ? 'black' : undefined}
                                                    />
                                                )}
                                            </React.Fragment>
                                        ))}
                                </div>
                            ) : (
                                <div className="np-pro-box">
                                    <h5>{phrase.no_results_found}</h5>
                                </div>
                            )}

                            {projectsMain.totalRecords > projectsMainPayload.sh_limit &&
                                totalPages > 1 && (
                                    <div className="d-flex justify-content-between align-items-center flex-wrap w-100 my-3 pagination-wrapper">
                                        <Pagination
                                            count={totalPages}
                                            page={projectsMainPayload.page}
                                            onChange={onHandlePage}
                                            siblingCount={3}
                                            showFirstButton
                                            showLastButton
                                            boundaryCount={2}
                                        />
                                    </div>
                                )}
                        </div>
                    ) : (
                        <div className={`searchRt ${completed ? 'closedComp' : ''}`}>
                            {completed ? null : (
                                <>
                                    {selectedCategories &&
                                    Array.isArray(selectedCategories) &&
                                    selectedCategories.length ? null : (
                                        <Banner bannerList={bannerList} />
                                    )}
                                </>
                            )}
                            {completed ? null : (
                                <div className="grid-card-view">
                                    <div className="d-flex filterCnt align-items-center mb-3">
                                        <Button
                                            variant="outlined"
                                            className="showFilter"
                                            onClick={toggleDrawer('left', true)}
                                        >
                                            <span className="material-icons">tune</span>{' '}
                                            {phrase.filter_by || 'Filter By'}
                                        </Button>
                                    </div>
                                    <div className="showOutlet">
                                        {!completed &&
                                            outletCount > 0 &&
                                            (isOutlet ? (
                                                <Button
                                                    className="outletBtn"
                                                    onClick={() => {
                                                        clearSearchFilter()
                                                        setProjectsMainPayload((prev) => ({
                                                            ...prev,
                                                            auction_format: 'normal',
                                                            page: 1,
                                                        }))
                                                        history.push('/search')
                                                    }}
                                                >
                                                    <img src="/assets/images/outlet_ledmax_btn1.png" />
                                                </Button>
                                            ) : (
                                                <PrimaryButton
                                                    className="outletBtn"
                                                    onClick={() => {
                                                        clearSearchFilter()
                                                        setProjectsMainPayload((prev) => ({
                                                            ...prev,
                                                            auction_format: 'outlet',
                                                            page: 1,
                                                        }))
                                                        history.push('/search/outlet')
                                                    }}
                                                >
                                                    <img src="/assets/images/outlet_ledmax_btn1.png" />
                                                </PrimaryButton>
                                            ))}
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center"></div>
                                </div>
                            )}
                            {showRecentlyClosedAuctionsSection && (
                                <div className="ml-3">
                                    <div className="mb-3 d-flex justify-content-start align-items-center">
                                        <div className="searchTitle" style={{ top: '8px' }}>
                                            {completed ? (
                                                <h3>{phrase.recently_closed_auctions}</h3>
                                            ) : null}
                                            <h6>
                                                {projectCompleted.total_onlycompleted == 0
                                                    ? 0
                                                    : projectCompleted.set_disp}{' '}
                                                OF{' '}
                                                {projectCompleted.total_onlycompleted == 0
                                                    ? 0
                                                    : projectCompleted.totalRecords}{' '}
                                                LOTS
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center"></div>
                                    {projcompletedloading ? (
                                        <Loader />
                                    ) : projectsMainCompleted.length ? (
                                        <>
                                            {projcompletedloading ? (
                                                <Loader />
                                            ) : (
                                                <div
                                                    className={`searchResults mt-4 ${auctionView}`}
                                                >
                                                    <Drawer
                                                        className="rightDrawer"
                                                        anchor={'right'}
                                                        open={state['right']}
                                                        onClose={toggleDrawer('right', false)}
                                                    >
                                                        {/* <ProductView data={state.data} /> */}
                                                    </Drawer>

                                                    {projectsMainCompleted.map((data, index) => (
                                                        <React.Fragment key={index}>
                                                            {auctionView === 'Grid' ? (
                                                                <>
                                                                    <GridView
                                                                        data={data}
                                                                        favId={`searchProd_${index}`}
                                                                        drawerHandler={toggleDrawer(
                                                                            'right',
                                                                            true,
                                                                            data,
                                                                        )}
                                                                        completed={true}
                                                                        fallbackAuctionFormat={
                                                                            isOutlet
                                                                                ? 'outlet'
                                                                                : undefined
                                                                        }
                                                                    />
                                                                </>
                                                            ) : (
                                                                <ListView
                                                                    data={data}
                                                                    favId={`searchProd_${index}`}
                                                                    drawerHandler={toggleDrawer(
                                                                        'right',
                                                                        true,
                                                                        data,
                                                                    )}
                                                                    completed={true}
                                                                    fallbackAuctionFormat={
                                                                        isOutlet
                                                                            ? 'outlet'
                                                                            : undefined
                                                                    }
                                                                />
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            )}
                                            <div
                                                className={`d-flex justify-content-${
                                                    completed ? 'between' : 'center'
                                                } align-items-center flex-wrap w-100 my-3 pagination-wrapper`}
                                            >
                                                {completed ? (
                                                    <Pagination
                                                        count={Math.ceil(
                                                            projectCompleted.totalRecords /
                                                                endedProjectsPayload.sh_limit,
                                                        )}
                                                        page={endedProjectsPayload.page}
                                                        onChange={onHandlePageEndedAuctions}
                                                        siblingCount={3}
                                                        showFirstButton
                                                        showLastButton
                                                        boundaryCount={2}
                                                    />
                                                ) : // <PrimaryButton
                                                //     label={`${phrase.view} ${phrase.recently_closed_auctions}`}
                                                //     onClick={() =>
                                                //         (window.location.href = '/search/completed')
                                                //     }
                                                // />
                                                null}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="np-pro-box">
                                            <h5>{phrase.no_results_found}!</h5>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                {/* Mobile view filter Options */}
                <div className="searchRt mobile-view">
                    {completed ? null : (
                        <>
                            {selectedCategories &&
                            Array.isArray(selectedCategories) &&
                            selectedCategories.length ? null : (
                                <Banner bannerList={bannerList} />
                            )}
                        </>
                    )}
                    {completed ? null : (
                        <div className="grid-card-view">
                            <div className="d-flex filterCnt align-items-center mb-3">
                                <Button
                                    variant="outlined"
                                    className="showFilter"
                                    onClick={toggleDrawer('left', true)}
                                >
                                    <span className="material-icons">tune</span>{' '}
                                    {phrase.filter_by || 'Filter By'}
                                </Button>
                            </div>
                            <div className="showOutlet">
                                {!completed &&
                                    outletCount > 0 &&
                                    (isOutlet ? (
                                        <Button
                                            className="outletBtn"
                                            onClick={() => {
                                                clearSearchFilter()
                                                setProjectsMainPayload((prev) => ({
                                                    ...prev,
                                                    auction_format: 'normal',
                                                    page: 1,
                                                }))
                                                history.push('/search')
                                            }}
                                        >
                                            <img src="/assets/images/outlet_ledmax_btn1.png" />
                                        </Button>
                                    ) : (
                                        <PrimaryButton
                                            className="outletBtn"
                                            onClick={() => {
                                                clearSearchFilter()
                                                setProjectsMainPayload((prev) => ({
                                                    ...prev,
                                                    auction_format: 'outlet',
                                                    page: 1,
                                                }))
                                                history.push('/search/outlet')
                                            }}
                                        >
                                            <img src="/assets/images/outlet_ledmax_btn1.png" />
                                        </PrimaryButton>
                                    ))}
                            </div>
                            <div className="d-flex justify-content-between align-items-center"></div>
                        </div>
                    )}
                </div>
                {!completed && (
                    <div className="searchCnt searcf d-flex justify-content-start align-items-start customContainer">
                        <div className="searchLt"></div>
                        <div className={`searchRt ${completed ? 'closedComp' : ''}`}>
                            {completed ? null : (
                                <>
                                    {selectedCategories &&
                                    Array.isArray(selectedCategories) &&
                                    selectedCategories.length ? null : (
                                        <Banner bannerList={bannerList} />
                                    )}
                                </>
                            )}
                            {showRecentlyClosedAuctionsSection && (
                                <div className="ml-3">
                                    <div className="mb-3 d-flex justify-content-start align-items-center">
                                        <div className="searchTitle">
                                            {!completed ? (
                                                <h3>{phrase.recently_closed_auctions}</h3>
                                            ) : null}
                                            <h6>
                                                {projectCompleted.total_onlycompleted == 0
                                                    ? 0
                                                    : projectCompleted.set_disp}{' '}
                                                OF{' '}
                                                {projectCompleted.total_onlycompleted == 0
                                                    ? 0
                                                    : projectCompleted.totalRecords}{' '}
                                                LOTS
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center"></div>
                                    {projcompletedloading ? (
                                        <Loader />
                                    ) : projectsMainCompleted.length ? (
                                        <>
                                            {projcompletedloading ? (
                                                <Loader />
                                            ) : (
                                                <div
                                                    className={`searchResults mt-4 ${auctionView}`}
                                                >
                                                    <Drawer
                                                        className="rightDrawer"
                                                        anchor={'right'}
                                                        open={state['right']}
                                                        onClose={toggleDrawer('right', false)}
                                                    >
                                                        {/* <ProductView data={state.data} /> */}
                                                    </Drawer>

                                                    {projectsMainCompleted.map((data, index) => (
                                                        <React.Fragment key={index}>
                                                            {auctionView === 'Grid' ? (
                                                                <>
                                                                    <GridView
                                                                        data={data}
                                                                        favId={`searchProd_${index}`}
                                                                        drawerHandler={toggleDrawer(
                                                                            'right',
                                                                            true,
                                                                            data,
                                                                        )}
                                                                        completed={true}
                                                                        fallbackAuctionFormat={
                                                                            isOutlet
                                                                                ? 'outlet'
                                                                                : undefined
                                                                        }
                                                                    />
                                                                </>
                                                            ) : (
                                                                <ListView
                                                                    data={data}
                                                                    favId={`searchProd_${index}`}
                                                                    drawerHandler={toggleDrawer(
                                                                        'right',
                                                                        true,
                                                                        data,
                                                                    )}
                                                                    completed={true}
                                                                    fallbackAuctionFormat={
                                                                        isOutlet
                                                                            ? 'outlet'
                                                                            : undefined
                                                                    }
                                                                />
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            )}
                                            <div
                                                className={`d-flex justify-content-${
                                                    completed ? 'between' : 'center'
                                                } align-items-center flex-wrap w-100 my-3 pagination-wrapper`}
                                            >
                                                {completed ? (
                                                    <Pagination
                                                        count={Math.ceil(
                                                            projectCompleted.totalRecords /
                                                                endedProjectsPayload.sh_limit,
                                                        )}
                                                        page={endedProjectsPayload.page}
                                                        onChange={onHandlePageEndedAuctions}
                                                        siblingCount={3}
                                                        showFirstButton
                                                        showLastButton
                                                        boundaryCount={2}
                                                    />
                                                ) : // <PrimaryButton
                                                //     label={`${phrase.view} ${phrase.recently_closed_auctions}`}
                                                //     onClick={() =>
                                                //         (window.location.href = '/search/completed')
                                                //     }
                                                // />
                                                null}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="np-pro-box">
                                            <h5>{phrase.no_results_found}!</h5>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* PRODUCT VIEW DRAWER */}
            </div>
        </>
    )
}
export default Search
